import type { RouteObject } from 'react-router-dom'

import { Component } from '@/modules/register/pages/Register'
import { RegisterRoutePathsEnum } from '@/modules/register/routes/registerRouteConfig.types'

export const REGISTER_ROUTES: RouteObject[] = [
  {
    element: <Component />,
    path: RegisterRoutePathsEnum.REGISTER,
  },
]
